export default __webpack_public_path__ + "static/media/polyplastics.972448fc.png";